<script lang="ts" setup>
import {storeToRefs} from "pinia";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";

const {darkMode} = storeToRefs(useNamaFlagsStore());
defineProps<{ isSpinner?: boolean }>()

</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 87.95 54.79" style="direction:rtl">
    <defs>
      <radialGradient id="radial-gradient-capital" v-if="!isSpinner" cx="21.26" cy="78.26" r="15.67"
                      gradientTransform="matrix(1, 0, 0, -1, 0, 87.81)"
                      gradientUnits="userSpaceOnUse">
        <stop offset="0" :stop-color="isSpinner?'#1b60a8':(darkMode?'#ede6e6':'#1b60a8')"/>
        <stop offset="1" :stop-color="isSpinner?'#174e9b':(darkMode?'#cbccd3':'#174e9b')"/>
      </radialGradient>
      <radialGradient id="radial-gradient-capital-2" cx="65.18" cy="81.43" r="16.7" xlink:href="#radial-gradient-capital"/>
      <radialGradient id="radial-gradient-capital-3" cx="19.87" cy="50.19" r="18.56" xlink:href="#radial-gradient-capital"/>
      <radialGradient id="radial-gradient-capital-4" cx="65.87" cy="50.03" r="19.64" xlink:href="#radial-gradient-capital"/>
      <radialGradient id="radial-gradient-capital-home" cx="21.26" cy="78.26" r="15.67" gradientTransform="matrix(1, 0, 0, -1, 0, 87.81)"
                      gradientUnits="userSpaceOnUse">
        <stop offset="0" stop-color="#1b60a8"/>
        <stop offset="1" stop-color="#174e9b"/>
      </radialGradient>
      <radialGradient id="radial-gradient-capital-home-2" cx="65.18" cy="81.43" r="16.7" xlink:href="#radial-gradient-capital-home"/>
      <radialGradient id="radial-gradient-capital-home-3" cx="19.87" cy="50.19" r="18.56" xlink:href="#radial-gradient-capital-home"/>
      <radialGradient id="radial-gradient-capital-home-4" cx="65.87" cy="50.03" r="19.64" xlink:href="#radial-gradient-capital-home"/>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path :class="[ isSpinner?'cls-capital-home-1':'cls-capital-1']"
              d="M18.83,1.61c-9,3-15,8.83-17.57,17.49H15c.2-.34.42-.67.65-1,2.77-3.79,6.64-5.34,11.2-5.35H41.26V0H28.92A31.75,31.75,0,0,0,18.83,1.61Z"/>
        <path :class="[ isSpinner?'cls-capital-home-2':'cls-capital-2']"
              d="M87.85,5.75,81.19,1.29A7.64,7.64,0,0,0,76.94,0H42.42V12.76H74.8A9.26,9.26,0,0,0,79.26,12h.06a6.56,6.56,0,0,0,1-.62l1.31-1L87.88,6a.16.16,0,0,0,0-.28Z"/>
        <path :class="[ isSpinner?'cls-capital-home-3':'cls-capital-3']"
              d="M39,41.3h0c-4.6,0-9.21.08-13.81-.12a12,12,0,0,1-9.37-5.06,15.9,15.9,0,0,1-1.49-15.65H.9C.71,21.28.54,22.11.41,23-1.25,33.47,2.13,42.35,10.65,49c5,3.9,10.93,5.46,17.19,5.76,2.53.12,5.06,0,7.67,0a.15.15,0,0,0,.15-.14c.41-4.29,1.26-8.35,3.92-12A.8.8,0,0,0,39,41.3Z"/>
        <path :class="[ isSpinner?'cls-capital-home-4':'cls-capital-4']"
              d="M71.31,20.78H45.13A1.21,1.21,0,0,0,43.91,22s0,.08,0,.12v.2A12.66,12.66,0,0,0,56.61,33.36H69.87a9.55,9.55,0,0,1,3.45.76,3.6,3.6,0,0,1,.07,6.48,9.9,9.9,0,0,1-3.55.79c-4.08.1-8.17,0-12.25.06a16.23,16.23,0,0,0-3.55.4c-5.67,1.38-10,6.81-10,12.28a.62.62,0,0,0,.62.61c9.21,0,18.43.11,27.63,0a14.78,14.78,0,0,0,12.89-7.41,18.12,18.12,0,0,0,2.58-10.52C87.44,27.43,80.67,20.8,71.31,20.78Z"/>
        <g class="cls-capital-5">
          <text :class="[isSpinner?'tw-fill-[#232323]':'dark:tw-fill-[#d1cbcb] tw-fill-[#232323]',{'dark:tw-fill-[#232323]':isSpinner}]"
                class="cls-capital-6"
                transform="translate(42.42 20.04)">BY
          </text>
          <text class="cls-capital-7"
                transform="translate(52.24 20.04)"></text>
          <text :class="[isSpinner?'tw-fill-[#174e9b] dark:!tw-fill-[#174e9b]':'dark:tw-fill-[#cbccd3] tw-fill-[#174e9b]']"
                class="cls-capital-7"
                transform="translate(54.55 20.04)">ECPA
          </text>
        </g>
      </g>
    </g>
  </svg>
</template>
<style scoped>
.cls-capital-1 {
  fill: url(#radial-gradient-capital);
}

.cls-capital-2 {
  fill: url(#radial-gradient-capital-2);
}

.cls-capital-3 {
  fill: url(#radial-gradient-capital-3);
}

.cls-capital-4 {
  fill: url(#radial-gradient-capital-4);
}

.cls-capital-home-1 {
  fill: url(#radial-gradient-capital-home);
}

.cls-capital-home-2 {
  fill: url(#radial-gradient-capital-home-2);
}

.cls-capital-home-3 {
  fill: url(#radial-gradient-capital-home-3);
}

.cls-capital-home-4 {
  fill: url(#radial-gradient-capital-home-4);
}

.cls-capital-5, .cls-capital-6, .cls-capital-7 {
  isolation: isolate;
}

.cls-capital-6, .cls-capital-7 {
  font-size: 4.72px;
  font-family: ArialMT, Arial;
}
</style>
